var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row align-center h-full"},[_c('div',{staticClass:"flex flex-col align-center"},[_c('zt-avatar',{attrs:{"text":_vm.getAvatarText,"size":"64px"}}),_c('h4',{staticClass:"text-lg font-bold pt-2"},[_vm._v(" "+_vm._s(_vm.$t('message.dashboard.hello'))+" "+_vm._s(_vm.userName))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }